// extracted by mini-css-extract-plugin
export default {"main_css_us":"SecondaryInput_main_css_us__DpROm","main_css_jp":"SecondaryInput_main_css_jp__hjZWa"};